import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { handleCopy } from "./CopyDocID";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { formatCustomDate } from "./DateManager";
import {
  faFileAlt,
  faArrowRightToBracket,
  faFileSignature,
  faArrowRightFromBracket,
  faCopy,
  faXmark,
  faCheck,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import {
  callGetJData,
  ViewDocument,
  displayInputData,
  handleCheckboxChange,
} from "./DocsManager";
import { handleDownload } from "./FileDownloadManager";
import "../Dashboard/Default/TabDocs/DocsTable.css";
import { handleInputChange } from "./DocsManager";
import AlertIconButton from "./AlertIconButton";

const getNestedValue = (obj, path) => {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
};
export const renderDataCellDocs = (item, col, context, idx) => {
  const value = getNestedValue(item, col.key);

  switch (col.DataType) {
    case "actions":
      return (
        <td key={`actions-${idx}`}>
          {item.Attachmeents &&
            item.Attachmeents.length > 0 &&
            item.Attachmeents.filter((ext) => ext !== "" && ext !== null).map(
              (ext, index) => (
                <button
                  title="download attachement"
                  key={index}
                  className="btn ActionsButton"
                  onClick={() =>
                    handleDownload(
                      item.DocId,
                      ext,
                      context.instanceId,
                      context.modelId
                    )
                  }
                >
                  {ext}
                </button>
              )
            )}

          <AlertIconButton docId={item.DocId} jError={item.ErrorMessage} />

          <button
            title={context.t("view document")}
            className="btn ActionsButton"
            onClick={() =>
              ViewDocument(
                item.DocId,
                item.ModelId,
                item.InstanceId,
                item.ClientId
              )
            }
          >
            <FontAwesomeIcon
              icon={faFileAlt}
              style={{ marginRight: "5px" }}
              className="fa-copy"
            />
          </button>

          {item.Input && Object.keys(item.Input).length > 0 && (
            <button
              title="Voir Input"
              className="btn ActionsButton"
              onClick={() => displayInputData(item.Input)}
            >
              <FontAwesomeIcon
                icon={faArrowRightToBracket}
                style={{ marginRight: "5px" }}
                className="fa-copy"
              />
            </button>
          )}

          <button
            title="voir jdata"
            className="btn ActionsButton"
            onClick={() =>
              callGetJData(item.InstanceId, item.DocId, item.ClientId)
            }
          >
            <FontAwesomeIcon
              icon={faArrowRightFromBracket}
              style={{ marginRight: "5px" }}
              className="fa-copy"
            />
          </button>
          {item.reviewURL !== undefined &&
            item.reviewURL !== null &&
            item.Status !== "completed" && (
              <button
                title="VideoCodage"
                data-toggle="tooltip"
                className="btn btn-outline-primary ActionsButton"
                onClick={() => context.openModal1(item, context.filteredIndex)}
              >
                <FontAwesomeIcon
                  icon={faFileSignature}
                  style={{ marginRight: "5px" }}
                />
              </button>
            )}
          <input
            type="checkbox"
            checked={context.selectedDocuments.includes(item.DocId)}
            onChange={(e) =>
              handleCheckboxChange(
                e,
                item.DocId,
                context.selectedDocuments,
                context.setSelectedDocuments
              )
            }
          />
        </td>
      );

    case "actionPlan01":
      return renderActionsColumn(item, context, idx);
    case "date":
      return (
        <td
          key={`date-${idx}`}
          style={{ lineHeight: "1", fontWeight: "normal", fontSize: "14px" }}
        >
          {formatCustomDate(value)}
        </td>
      );

    case "copyId":
      return (
        <td key={`actions-${idx}`}>
          <CopyToClipboard text={value} onCopy={() => handleCopy(value)}>
            <button
              className="btn btn-sm"
              data-toggle="tooltip"
              title="Copy instanceId"
            >
              <FontAwesomeIcon icon={faCopy} />
            </button>
          </CopyToClipboard>
        </td>
      );
    case "validation":
      return (
        <td
          key={`validation-${idx}`}
          style={{
            textAlign: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontSize: "14px",
          }}
        >
          {item.Status !== "invalid" ? (
            <select
              className="form-control"
              value={
                item.isvalid !== undefined
                  ? item.isvalid
                    ? "true"
                    : "false"
                  : ""
              }
              onChange={(e) => {
                handleInputChange(
                  e,
                  item.DocId,
                  "isvalid",
                  context.setSelectedDocuments,
                  context.data,
                  context.setData
                );
              }}
              style={{
                width: "100%",
                textAlign: "center",
                height: "25px",
                fontSize: "12px",
                padding: "1px",
                color: item.isvalid ? "#006400" : "#8B0000",
                backgroundColor: item.isvalid ? "#90EE90" : "#FFA07A",
              }}
            >
              <option value="">Valide</option>
              <option value="true">Vrai</option>
              <option value="false">Faux</option>
            </select>
          ) : (
            <div>{item.isvalid ? "Vrai" : "Faux"}</div>
          )}
        </td>
      );

    case "bValid":
      return (
        <td key={`actions-${idx}`}>
          {value === "true" || value === true ? (
            <FontAwesomeIcon icon={faCheck} />
          ) : value === "" || value === null || value === undefined ? (
            <span></span>
          ) : (
            <FontAwesomeIcon icon={faXmark} />
          )}
        </td>
      );
    case "complexite":
      return (
        <td key={`complexite-${idx}`} style={{ fontSize: "14px" }}>
          {item.Status !== "invalid" ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              {["Simple", "Moyen", "Complexe"].map((Complexite, index) => {
                const colors = ["green", "orange", "red"];
                const isSelected = item.Complexite === Complexite;
                const baseColor = colors[index];
                const backgroundColor = isSelected ? baseColor : "#f0f0f0";
                const color = isSelected ? "white" : baseColor;

                return (
                  <button
                    key={Complexite}
                    style={{
                      backgroundColor,
                      color,
                      border: `1px solid ${baseColor}`,
                      padding: "5px 10px",
                      margin: "0 5px",
                      cursor: "pointer",
                      borderRadius: "5px",
                    }}
                    onClick={() =>
                      handleInputChange(
                        { target: { value: Complexite } },
                        item.DocId,
                        "Complexite",
                        context.setSelectedDocuments,
                        context.data,
                        context.setData
                      )
                    }
                  >
                    {Complexite[0]}
                  </button>
                );
              })}
            </div>
          ) : (
            <div>{item.Complexite}</div>
          )}
        </td>
      );
    default:
      return (
        <td
          key={`default-${idx}`}
          style={{
            fontWeight: col.bold ? "bold" : "normal",
            width: "100px",
            fontSize: "14px",
          }}
        >
          {value}
        </td>
      );
  }
};

//render action data column for plan01
export const renderActionsColumn = (item, context, filteredIndex) => {
  const { openModal, setSelectedDocumentId, openModal1, selectedDocuments, t } =
    context;

  return (
    <td key={`actionPlan01-${filteredIndex}`} style={{ whiteSpace: "normal" }}>
      {item.Attachmeents &&
        item.Attachmeents.length > 0 &&
        item.Attachmeents.filter(
          (extension) => extension !== "" && extension !== null
        ).map((extension, index) => (
          <button
            title="download attachment"
            key={index}
            className="btn ActionsButton"
            onClick={() => {
              handleDownload(
                item.DocId,
                extension,
                item.InstanceId,
                item.ModelId
              );
            }}
          >
            {extension === "jpg" && (
              <img
                src="https://cdn-icons-png.flaticon.com/256/29/29072.png"
                alt="JPG Icon"
                style={{ height: "22px", width: "22px" }}
              />
            )}
            {extension === "png" && (
              <img
                src="https://cdn-icons-png.flaticon.com/256/29/29264.png"
                alt="PNG Icon"
                style={{ height: "22px", width: "22px" }}
              />
            )}
            {extension === "dwg" && (
              <img
                src="https://cdn-icons-png.flaticon.com/256/29/29072.png"
                alt="DWG Icon"
                style={{ height: "22px", width: "22px" }}
              />
            )}
            {extension}
          </button>
        ))}
      <button
        title={t("upload attachement")}
        className="btn ActionsButton"
        onClick={() => {
          openModal();
          setSelectedDocumentId(item.DocId);
        }}
      >
        <FontAwesomeIcon
          icon={faUpload}
          style={{ marginRight: "5px" }}
          className="fa-copy"
        />
      </button>
      <button
        title={t("view document")}
        className="btn ActionsButton"
        onClick={() =>
          ViewDocument(item.DocId, item.ModelId, item.InstanceId, item.ClientId)
        }
      >
        <FontAwesomeIcon
          icon={faFileAlt}
          style={{ marginRight: "5px" }}
          className="fa-copy"
        />
      </button>
      {item.Input && Object.keys(item.Input).length > 0 && (
        <button
          title="Voir Input"
          className="btn ActionsButton"
          onClick={() => displayInputData(item.Input)}
        >
          <FontAwesomeIcon
            icon={faArrowRightToBracket}
            style={{ marginRight: "5px" }}
            className="fa-copy"
          />
        </button>
      )}
      {item.reviewURL !== undefined &&
        item.reviewURL !== null &&
        item.Status !== "completed" && (
          <button
            title="VideoCodage"
            className="btn ActionsButton"
            onClick={() => openModal1(item, filteredIndex)}
          >
            <FontAwesomeIcon
              icon={faFileSignature}
              style={{ marginRight: "5px" }}
              className="fa-copy"
            />
          </button>
        )}
      <input
        type="checkbox"
        checked={selectedDocuments.includes(item.DocId)}
        onChange={(e) =>
          handleCheckboxChange(
            e,
            item.DocId,
            selectedDocuments,
            context.setSelectedDocuments
          )
        }
      />
    </td>
  );
};
